import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-1022",
  "use": "icon-1022-usage",
  "viewBox": "0 0 24.671 27.516",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24.671 27.516\" id=\"icon-1022\">\r\n  <path id=\"icon-1022_wushuju\" d=\"M63.035,24.231l-7.08,0a1.026,1.026,0,0,1-.867-.318,2.025,2.025,0,0,1-.186-.911V2.721a1.5,1.5,0,0,1,.339-.82,1.459,1.459,0,0,1,.74-.462H66.927V4.365a2.9,2.9,0,0,0,.576,1.8,3.87,3.87,0,0,0,1.452.947l.121.044,3.876,0v3.5l1.223.943.21.218v-6.3L68.125,0H55.955a2.575,2.575,0,0,0-1.727.884,2.9,2.9,0,0,0-.759,1.776V22.99a3.214,3.214,0,0,0,.487,1.805,2.191,2.191,0,0,0,1.17.769,3.014,3.014,0,0,0,.826.1l9.661,0A8.491,8.491,0,0,1,63.9,24.9ZM68.36,2.119l4.083,3.607-3.107,0a2.365,2.365,0,0,1-.759-.5,1.566,1.566,0,0,1-.223-.839Zm9.447,23.456a1.138,1.138,0,1,1-1.608,1.61l-3.526-3.524a7.538,7.538,0,1,1,1.608-1.613l3.526,3.526Zm-9.578-2.306a5.663,5.663,0,1,0-5.662-5.664,5.672,5.672,0,0,0,5.662,5.664Z\" transform=\"translate(-53.469)\" fill=\"#00d0b8\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/1022.svg
// module id = gAGB
// module chunks = 5